"use client";

import { c as _c } from "react/compiler-runtime";
import { toast } from "sonner";
import { useTranslations } from "next-intl";
import { demoRequestFormSchema, type DemoRequestFormData } from "./form-fields";
import { useFormSubmit } from "@/hooks/use-form-submit";
interface UseDemoRequestFormProps {
  onSubmit: (formData: FormData) => Promise<{
    errors?: string[];
    success?: boolean;
  }>;
}
const transformer = (data: DemoRequestFormData) => {
  const formData = new FormData();
  formData.append("firstName", data.firstName);
  formData.append("lastName", data.lastName);
  formData.append("email", data.email);
  formData.append("company", data.company || "");
  formData.append("venueType", data.venueType || "");
  formData.append("comments", data.comments || "");
  return formData;
};
const buildDefaultValues = () => {
  return {
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    venueType: "",
    comments: ""
  };
};
export function useDemoRequestForm(t0) {
  const $ = _c(9);
  const {
    onSubmit
  } = t0;
  const t = useTranslations("welcome.demoRequestForm");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = buildDefaultValues();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSubmit) {
    t2 = {
      onSubmit,
      schema: demoRequestFormSchema,
      defaultValues: t1,
      transformer
    };
    $[1] = onSubmit;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const formService = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      success: _temp,
      error: _temp2
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const notificationService = t3;
  let t4;
  if ($[4] !== t) {
    t4 = {
      getSuccessMessage: () => t("successMessage"),
      getErrorMessage: () => t("errorMessage")
    };
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const i18nService = t4;
  let t5;
  if ($[6] !== formService || $[7] !== i18nService) {
    t5 = {
      formService,
      notificationService,
      i18nService
    };
    $[6] = formService;
    $[7] = i18nService;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return useFormSubmit(t5);
}
function _temp2(message_0) {
  return toast.error(message_0);
}
function _temp(message) {
  return toast.success(message);
}